import { COUNTRIES } from '@/utils/geoData';

// Convertit un code ISO-2 en emoji drapeau (ex: 'FR' → '🇫🇷')
const _isoToFlag = (code) =>
  [...code.toUpperCase()].map(ch =>
    String.fromCodePoint(0x1F1E6 + ch.charCodeAt(0) - 65)
  ).join('');

// Map exhaustive city → flag emoji, construite depuis geoData
const CITY_FLAG = Object.fromEntries(
  COUNTRIES.flatMap(({ code, cities = [] }) =>
    cities.map(city => [city, _isoToFlag(code)])
  )
);

// Aliases anglais → ISO-2 pour les villes dont le nom diffère du français
const EN_ALIASES = {
  'London': 'GB', 'London City': 'GB',
  'Brussels': 'BE', 'Antwerp': 'BE', 'Ghent': 'BE',
  'Lisbon': 'PT',
  'Vienna': 'AT', 'Salzburg': 'AT',
  'Barcelona': 'ES', 'Seville': 'ES', 'Valencia': 'ES', 'Saragossa': 'ES',
  'Hamburg': 'DE', 'Frankfurt': 'DE', 'Munich': 'DE', 'Cologne': 'DE',
  'The Hague': 'NL', 'The Hague (Den Haag)': 'NL',
  'Geneva': 'CH', 'Basel': 'CH', 'Bern': 'CH',
  'Copenhagen': 'DK', 'Aarhus': 'DK',
  'Warsaw': 'PL', 'Krakow': 'PL', 'Cracow': 'PL',
  'Moscow': 'RU', 'Saint Petersburg': 'RU', 'St Petersburg': 'RU',
  'Kyiv': 'UA', 'Kiev': 'UA',
  'Bucharest': 'RO',
  'Athens': 'GR',
  'New York': 'US', 'New York City': 'US', 'NYC': 'US',
  'Los Angeles': 'US', 'Chicago': 'US', 'Houston': 'US',
  'Washington': 'US', 'Washington DC': 'US',
  'San Francisco': 'US', 'Miami': 'US', 'Boston': 'US', 'Atlanta': 'US',
  'Nairobi': 'KE', 'Mombasa': 'KE',
  'Addis Ababa': 'ET',
  'Cape Town': 'ZA', 'Johannesburg': 'ZA', 'Durban': 'ZA',
  'Algiers': 'DZ',
  'Tunis': 'TN',
  'Cairo': 'EG', 'Alexandria': 'EG',
  'Casablanca': 'MA', 'Rabat': 'MA', 'Marrakesh': 'MA', 'Marrakech': 'MA',
  'Accra': 'GH',
  'Lagos': 'NG', 'Abuja': 'NG',
  'Dakar': 'SN',
  'Abidjan': 'CI',
  'Douala': 'CM', 'Yaoundé': 'CM',
  'Kinshasa': 'CD',
  'Luanda': 'AO',
  'Maputo': 'MZ',
  'Antananarivo': 'MG',
};

const EN_FLAG = Object.fromEntries(
  Object.entries(EN_ALIASES).map(([city, code]) => [city, _isoToFlag(code)])
);

/**
 * Retourne l'emoji drapeau de la ville, ou '📍' si inconnue.
 * Tolère les variantes de casse et les noms en anglais.
 */
export function cityFlag(c) {
  if (!c) return '📍';
  if (CITY_FLAG[c]) return CITY_FLAG[c];
  if (EN_FLAG[c]) return EN_FLAG[c];
  const low = c.trim().toLowerCase();
  const key =
    Object.keys(CITY_FLAG).find(k => k.toLowerCase() === low) ||
    Object.keys(EN_FLAG).find(k => k.toLowerCase() === low);
  return (key && (CITY_FLAG[key] || EN_FLAG[key])) || '📍';
}
